import React,{useState} from 'react';
import { withRouter,NavLink } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { Button, Modal } from 'react-bootstrap';
import "./contactUs.css"
import Contact from "../Contact/Contact"

const ContactUs = () =>  {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <section className="contactUsPageMain">
                <div className="container">
                    <div className="text-center headingDiv">
                        <h1>Contact Us</h1>
                        <p>Let’s start a conversation, we'd love to hear  from you.</p>         
                    </div>
                    <div className="row ai-center">
                        <div className="col-lg-4">
                            <div className="contactCard1">
                                <div>
                                    <h5>Media, Advertising, and Business Enquiries</h5>
                                    <p>For all media, advertising opportunities, and business related enquiries, please get in touch.    </p>
                                </div>
                                <div>
                                    <Nav.Link  onClick={handleShow}>Contact Corporate Enquires</Nav.Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="contactCard2">
                                <div>
                                    <h5>FAQS, Terms and Conditions, and Guidelines </h5>
                                    <p>Have questions? Want to learn how to use r3 or know your responsibilities when using the site? We have you covered.</p>
                                </div>
                                <div className="text-center">
                                    <Nav.Link href="/user-guide" className="card2btn">Site User Guide</Nav.Link>
                                    {/* <a href="#" className="text-uppercase submitReq">Submit a request</a> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="contactCard3">
                                <div>
                                    <h5>Customer support, general Enquires, complaints or compliments</h5>
                                    <p> Having issues? Have a question that needs a personal touch? Want to give a yay or nay? Flick us an email and we'll get right back at you. </p>
                                </div>
                                <div className="text-center">
                                    <Nav.Link  onClick={handleShow} className="card2btn">Contact Customer Service</Nav.Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Modal show={show} onHide={handleClose} className="contactModal">
                <Modal.Header >
                <div className=" headerColor  text-center col-12">
                  <h3 className="bold-font h4 mb-0 themeColor2 text-center"><i className="fa fa-envelope" /> Contact Us</h3>
                </div>
                <span className="close" onClick={handleClose}><i class="fa fa-times" aria-hidden="true"></i></span>
                </Modal.Header>
                <Contact />
               
            </Modal>
        </>
    )
  }

export default ContactUs;